import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { CheckinInventoryRedux } from '../Redux/CheckinInventoryRedux'

const checkinInventoryCrudObservable = createCRUDObservable({
  mainRedux: CheckinInventoryRedux,
  reduxPath: 'checkin_inventory',
})

export const checkinInventoryObservers = Object.assign({}, checkinInventoryCrudObservable.observers, {})

export const checkinInventoryEpic = combineEpics(
  checkinInventoryCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CheckinInventoryObservable.js